import { render } from "./ModalPieceEtudiant.vue?vue&type=template&id=735e8b90&scoped=true&ts=true"
import script from "./ModalPieceEtudiant.vue?vue&type=script&lang=ts"
export * from "./ModalPieceEtudiant.vue?vue&type=script&lang=ts"

import "./ModalPieceEtudiant.vue?vue&type=style&index=0&id=735e8b90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735e8b90"]])

export default __exports__